import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { CountryItem, LogisticService } from '../../../services/logistic.service';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-holidays-view',
  templateUrl: './holidays-view.component.html',
  styleUrls: ['./holidays-view.component.css']
})
export class HolidaysViewComponent implements OnInit {
    public setting?: Setting;

    public selectListCountries: CountryItem[] = [];

    public itemsListYears: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(561))[0];
    }

    private async loadCountries(): Promise<void> {
        this.selectListCountries = await this.logistic.getCountries();
    }

    private async loadYears(): Promise<void> {
        if (!!this.setting) {
            this.itemsListYears = await this.datatask.Post(563, { country_id: this.setting.country_id });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'holiday':
                this.stateService?.go('holiday', {
                    p2_holyday_keyno: '0',
                    country_id: this.setting?.country_id
                });
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'country_id':
                this.loadYears();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCountries();
        this.loadYears();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    country_id: string;
}
